import { type ComponentProps, type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';

export const Textarea = ({ className, ...props }: ComponentProps<'textarea'>): ReactElement => (
  <textarea
    data-slot="textarea"
    className={cn(
      'text-sm field-sizing-content min-h-16 w-full min-w-0 rounded-lg border px-4 py-2',
      'transition-[color,box-shadow] outline-none',
      'disabled:pointer-events-none disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-300',
      'placeholder:text-gray-400 focus-visible:bg-gray-100 leading-4.5 placeholder-shown:bg-gray-100 placeholder-shown:border-teal-300',
      'read-only:cursor-default read-only:border-white read-only:bg-mint-100 read-only:text-denim-800',
      'read-only:focus-visible:bg-mint-100',
      'border-teal-500 bg-mint-100 text-denim-800',
      className
    )}
    {...props}
  />
);
